module.exports = __webpack_public_path__ + "vrbo-fav.png?19638c2e3bd44f3a84004f322cae56f3";